import { financingNeedSectionValidationMap } from './sections/financingNeedSection/validations';
import { purposeSectionValidationMap } from './sections/purposeSection/validations';

export const hausbankFiancingNeedFieldValidation = {
  ...financingNeedSectionValidationMap,
  ...purposeSectionValidationMap,
};
